import { render, staticRenderFns } from "./payWatch.vue?vue&type=template&id=2dcdf394&scoped=true"
import script from "./payWatch.vue?vue&type=script&lang=js"
export * from "./payWatch.vue?vue&type=script&lang=js"
import style0 from "./payWatch.vue?vue&type=style&index=0&id=2dcdf394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdf394",
  null
  
)

export default component.exports